import React from "react";
import Footer from "../components/footer/en/Footer";
import Header from "../components/header/en/Header";
import Contents from "../components/pages/editResume/en/Contents";

const EditResume = () => {
    return (
        <>
            <Header />
            <Contents />
            <Footer />
        </>
    );
}

export default EditResume;